import React, { Component } from 'react';
import Grid from 'screens/components/basic/Grid';
import { connect } from 'react-redux';
import { bulkTransferAddCrumb } from 'utils/breadcrumbInfo';
import LOOKUP from 'constants/lookup';
import * as types from 'constants/actionTypes';
import BarcodeReader from 'library/readBarcode';
import { getProductQuantity, getPurchaseOrderForBulkTransfer, getWarehouses, sendBulkTransfer, getProductsAutocompleteFromWarehouse, getCategories, getProductsGroupedFromWarehouse } from 'actions/EntityActions';
import { clearFormInput, formInput, setBulkTransferBranchFrom, setBulkTransferBranchTo } from 'actions/FormActions';
import { showError } from 'actions/CommonActions';
import WithRouter from 'custom/withRouter';
// Basic Components
import SelectInput from 'screens/components/basic/SelectInput';
import AutoCompleteBulkTransfer from 'screens/components/basic/AutoCompleteBulkTransfer';
import SelectInputPackageReference from 'screens/components/basic/SelectInputPackageReference';
import CardSimple from 'screens/components/basic/CardSimple';
import Pagination from 'screens/components/basic/Pagination';
import TextInput from 'screens/components/basic/TextInput';
import ToggleInput from 'screens/components/basic/ToggleInput';
import Button from 'screens/components/basic/Button';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInput from 'screens/components/advanced/DialogInput';

import TextField from '@mui/material/TextField';
import SearchPOFilterBulkTrasfer from './searchPOFilterBulkTrasfer'
import ExcelUploadBulkTransfer from './excelUploadBulkTransfer';
import ProductCategoriesListBulkTrasfer from './ProductCategoriesListBulkTrasfer';

class BulkTransferSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            warehouses: null,
            branchFrom: 1,
            productListEdit: [],
            warehouseFrom: null,
            branchTo: "",
            warehouseTo: "",
            searchText: "",
            warehouseTypeOption: "",
            warehouseTypeItems: [
                {
                    text: 'Storage',
                    value: 1
                },
                {
                    text: 'Sell',
                    value: 2
                },
                {
                    text: 'Damage',
                    value: 3
                }
            ],
            branchToOptions: [],
            showWarehouseType: false,
            productsTransfer: [],
            productsWarehouses: [],
            showDialogPO: false,
            showDialogCat: false,
            selectedPOOpen: false,
            selectedPO: {},
            dialogPOTitle: "",
            categoryListEdit: [],
            activePage: 1,
            transferTitle: ""

        };
        this.mapBulkListTransfer = this.mapBulkListTransfer.bind(this);
        this.getProductOptions = this.getProductOptions.bind(this);
        this.addProductToTransfer = this.addProductToTransfer.bind(this);
        this.mapProductTransfer = this.mapProductTransfer.bind(this);
        this.selectPackageReference = this.selectPackageReference.bind(this);
        this.selectQty = this.selectQty.bind(this);
        this.sendBulkTransfer = this.sendBulkTransfer.bind(this);
        this.addTitle = this.addTitle.bind(this);

        this.barcodeReader = new BarcodeReader();
    }

    componentDidUpdate(prevProps) {
        if (this.props.branchFrom !== prevProps.branchFrom && this.props.branchFrom) {
            this.props.getCategories(this.props.branchFrom)
        }
    }

    processAllProductCategoryLst() {
        if (Array.isArray(this.props.productsByCategory) && this.props.productsByCategory.length > 0) {
            let arrayModel = []
            this.props.productsByCategory.forEach(element => {
                let selectedQuantity = element.categoryPackageReferenceSelectedValue == null ? element.warehouses[0].quantity : element.categoryPackageReferenceSelectedQuantity || 0;
                let selectedValue = element.categoryPackageReferenceSelectedValue == null ? element.warehouses[0].packageReference : element.categoryPackageReferenceSelectedValue || 0;
                let model = {
                    productId: element.productId,
                    ProductName: element.productName,
                    SKU: element.productSKU,
                    PackageReference: selectedValue.split('|')[0],
                    packageReferenceSelected: selectedValue.split('|')[0],
                    CurrentQty: selectedQuantity,
                    QtyToTransfer: 0
                }
                arrayModel.push(model);
            });
            if (arrayModel.length == 0) {
                this.props.showBulkTransferUpdateSnackbar("These products have been added already.");
                this.setState({ ...this.state, showDialogCat: false });
            } else {
                // Assuming arrayModel and productsTransfer are arrays of objects with a unique identifier, such as productId.
                let uniqueProductIds = new Set(this.state.productsTransfer.map(c => ({
                    productId: c.productId,
                    packageReference: c.packageReferenceSelected
                })));

                let uniqueProductIdsArray = Array.from(uniqueProductIds);

                // Filter the arrayModel to include only the elements that are not in productsTransfer.
                let newProducts = arrayModel.filter(element => {
                    return !uniqueProductIdsArray.some(objTransfer =>
                        objTransfer.productId === element.productId &&
                        objTransfer.packageReference === element.PackageReference
                    );
                });

                let productsTransfer = this.state.productsTransfer.concat(newProducts);
                this.setState({ ...this.state, productsTransfer, selectedPOOpen: false, showDialogCat: false }, () => {
                    arrayModel.forEach((element) => {
                        this.props.getProductQuantity({
                            productId: element.productId,
                            warehouseId: this.state.warehouseFrom,
                            packageReference: element.PackageReference || ""
                        })
                    })
                });
            }
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.props.productsWarehouses !== newProps.productsWarehouses && newProps.productsWarehouses != undefined) {
            this.setState({ ...this.state, productsWarehouses: newProps.productsWarehouses.list })
        }

        if (newProps.branchFrom && this.props.branchFrom !== newProps.branchFrom) {
            let branchOptions = this.props.allBranches.filter(x => x.value != newProps.branchFrom);
            this.setState({ ...this.state, showWarehouseType: true, branchFrom: newProps.branchFrom, branchToOptions: branchOptions });
            this.props.clearFormInput("transferTableSelectedRows")
            this.props.clearFormInput("bulkTransferBranchTo");
            this.props.clearFormInput("bulkTransferWarehouseTo");
            this.props.clearFormInput("bulkTransferWarehouseFrom");
            this.props.getWarehouses(newProps.branchFrom);
        }

        if (newProps.branchFrom && this.props.branchFrom !== newProps.branchFrom ) {
            this.setState({ ...this.state, branchFrom: newProps.branchFrom });
        }
        if (newProps.warehouseFrom && this.props.warehouseFrom !== newProps.warehouseFrom && this.state.warehouseTypeOption) {
            const warehouseId = this.state.warehouseTypeOption.filter(x => x.type == newProps.warehouseFrom)[0].id;            
            this.setState({ ...this.state, warehouseFrom: warehouseId, productsTransfer: [] });
        }

        if (newProps.warehouses && this.props.warehouses !== newProps.warehouses) {
            this.setState({ ...this.state, warehouseTypeOption: newProps.warehouses });
        }

        if (newProps.branchTo && this.props.branchTo !== newProps.branchTo ) {
            this.setState({ ...this.state, branchTo: newProps.branchTo });
        }

        if (newProps.warehouseTo && this.props.warehouseTo != newProps.warehouseTo) {
            this.setState({ ...this.state, warehouseTo: newProps.warehouseTo });
        }

        if (newProps.POSelected && this.props.POSelected != newProps.POSelected) {
            if (this.state.showDialogPO) {
                let selectedPO = newProps.POSelected[0] == undefined ? this.props.POSelected : newProps.POSelected[0];
                let POSelected = newProps.purchaseOrders[selectedPO];
                this.setState({ ...this.state, selectedPOOpen: true, dialogPOTitle: "PO #" + POSelected.id, selectedPO: POSelected });
            }
        }

        if (newProps.bulkTransferSuccess && this.props.bulkTransferSuccess != newProps.bulkTransferSuccess) {
            this.sendToBulkTransferPage();
        }


        if (newProps.productQuantity && this.props.productQuantity !== newProps.productQuantity) {
            if (newProps.productQuantity.quantity === 0) {
                const tempList = this.state.productsTransfer
                                .filter(x => !(x.productId === newProps.productQuantity.productId && x.PackageReference === newProps.productQuantity.packageReference))
                                .map(item => {
                                    return {
                                        ...item,
                                        PackageReference: item.PackageReference || "No Lot Number",
                                        CurrentQty: 0
                                    }
                                });
                this.setState({ ...this.state, productsTransfer: tempList });
                this.props.showBulkTransferUpdateSnackbar("Product out of stock.");
            }
            else {
                // console.log(this.props.productQuantity)
                const { productId, packageReference } = newProps.productQuantity || {};

                const updatedProductIndex = this.state.productsTransfer.findIndex(x => x.productId === productId);
                // console.log(updatedProductIndex)

                let tempProduct = this.state.productsTransfer.find(x => x.productId === productId);
                tempProduct = {
                    ...tempProduct,
                    PackageReference: tempProduct.PackageReference || "No Lot Number",
                    CurrentQty: newProps.productQuantity.quantity
                }

                // console.log(tempProduct)
                const tempList = this.state.productsTransfer;
                tempList[updatedProductIndex] = tempProduct;
                // console.log(tempList)
                this.setState({ ...this.state, productsTransfer: tempList });
            }
        }

        if (this.props.bulkTransferScannedTime !== newProps.bulkTransferScannedTime && newProps.bulkTransferScannedTime != null && newProps.bulkTransferScannedTime != undefined) {
            if (newProps.bulkTransferScanProductData && newProps.bulkTransferScanProductData.length > 0) {
                this.addProductToTransfer(newProps.bulkTransferScanProductData[0]);
            } else {
                this.props.showBulkTransferUpdateSnackbar("Product not found");
            }
        }
        if (newProps.products) {
            if (newProps.products.length > 0 && newProps.products !== this.props.products) {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        productList: [...newProps.products]
                    };
                });
            }
        }

        if (newProps.productsListEdit) {
            if (newProps.productsListEdit.length > 0 && newProps.productsListEdit !== this.props.productsListEdit) {
                this.productSelected(newProps.productsListEdit);
            }
        }

        if ((newProps.isHighTide && this.props.isHighTide !== newProps.isHighTide) || (newProps.isInspired && this.props.isInspired !== newProps.isInspired)) {
            this.props.formInput(true, "needReceive");
        }
    }

    componentDidMount() {
        window.addEventListener("keypress", this.barcodeListener);
        if (this.props.isHighTide || this.props.isInspired) {
            this.props.formInput(true, "needReceive");
        }
    }

    componentWillUnmount() {
        this.props.clearFormInput("bulkTransferBranchFrom");
        this.props.clearFormInput("bulkTransferBranchTo");
        this.props.clearFormInput("bulkTransferWarehouseTo");
        this.props.clearFormInput("bulkTransferWarehouseFrom");
        this.props.clearFormInput("bulkTransferTitle");
        this.props.clearFormInput("product");
        this.props.clearFormInput("bulkTransferPoFilter")
        window.removeEventListener("keypress", this.barcodeListener);
    }

    barcodeListener = () => {
        if (document.activeElement.tagName != "INPUT") {
            this.barcodeReader.listening(this.getProductByBarcode);
        }
    }

    getProductByBarcode = (barcode) => {
        const model = {
            WarehouseId: this.state.warehouseFrom,
            Barcode: barcode
        }
        this.props.getProductsAutocompleteFromWarehouse(model);
    }

    sendToBulkTransferPage = () => {
        this.props.navigate("/bulktransferproduct");
    }

    getPurchaseOrders = () => {
        const model = {
            id: this.props.purchaseNumber || null,
            branchId: this.state.branchFrom || 0,
            description: "",
            paymentDueDate: this.props.date || null,
            dateExpected: this.props.dateExpected || null,
            createdDate: null,
            status: 3,
            total: null,
            orderBy: "DESC",
            sortBy: this.state.sortBy,
            page: this.state.activePage,
            itemsPerPage: 15
        };
        this.props.getPurchaseOrders(model);
    }
    searchProductByCategory = () => {
        this.setState({ activePage: 1 }, this.searchProducts);
    }
    selectAllProductsByCategory = () => {
        this.setState({ activePage: 1 }, this.addAllProductsToTransfer);
    }
    searchProducts = () => {
        if (this.props.categoryIdSearch) {
            const model = {
                page: this.state.activePage,
                itemsPerPage: this.state.itemsPerPage,
                categoryId: this.props.categoryIdSearch,
                branchId: this.props.branchFrom,
                WarehouseId: this.state.warehouseFrom

            };
            this.props.getProductsByCategory(model);
        }
        else {
            this.props.showError(
                <div>
                    <p>It is necessary to select one Category for search.</p>
                </div>
            )
        }
    }

    transferArrayToOption = (list) => {
        list.reduce((acc, item) => {
            acc.push({ value: item.id, text: item.name });
            return acc;
        }, []);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getPurchaseOrders);
    }

    changeProductPage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.searchProducts);
    }

    mapBulkListTransfer = (value) => {
        return value != "" ? (value.map((item) => {
            return {
                warehouseType:
                    item.type === 1
                        ? "Storage"
                        : item.type === 2
                            ? "Store (Sell)"
                            : "Damage",
                id: item.id
            };
        })) : "";
    }

    getProductOptions = () => {
        return (this.props.productsWarehouses && this.props.productsWarehouses.list ? this.props.productsWarehouses.list : [] || []).map(item => {
            return {
                text: item.productName,
                value: item.productId,
                product: item
            };
        });
    }

    addProductToTransfer = (product) => {
        const productFound = this.state.productsTransfer.filter(x => x.productId === product.productId);
        let selectedPackageReference = "";
        if (productFound.length === 0) {
            if (product.warehouses.length === 1) {
                this.props.getProductQuantity({
                    productId: product.productId,
                    warehouseId: this.state.warehouseFrom,
                    packageReference: product.warehouses[0].packageReference || ""
                });
                selectedPackageReference = product.warehouses[0].packageReference;
            }
            selectedPackageReference = selectedPackageReference == "" ? product.warehouses[0].packageReference : selectedPackageReference;
            const qty = product.warehouses[0].quantity;
            const model = {
                productId: product.productId,
                ProductName: product.productName,
                SKU: product.productSKU,
                PackageReference: product.warehouses,
                packageReferenceSelected: selectedPackageReference,
                CurrentQty: qty,
                QtyToTransfer: 0
            };
            this.setState({ ...this.state, productsTransfer: [...this.state.productsTransfer, model] });
            
        } else {
            this.props.showBulkTransferUpdateSnackbar("This product has been added already.");
        }
    }

    getProductFromPO = () => {
        this.setState({ ...this.state, showDialogPO: true });
    }

    getProductFomCategories = () => {
        this.setState({ ...this.state, showDialogCat: true });
    }

    closeDialogTrasferFromPO = () => {
        this.setState({ ...this.state, showDialogPO: false });
    }

    closeDialogTrasferFromCategories = () => {
        this.setState({ ...this.state, showDialogCat: false });
    }

    selectPackageReference = (id, selectedItem) => {
        this.setState(prevState => {
            const { value = "", quantity = 0 } = selectedItem || {};
            const updatedProductsTransfer = prevState.productsTransfer.map(product => {
                if (product.productId === id) {
                    return {
                        ...product,
                        packageReferenceSelected: value || "",
                        CurrentQty: quantity
                    };
                }
                return product;
            });
            this.props.formInput(updatedProductsTransfer, "productsTransfer");
            return { productsTransfer: updatedProductsTransfer };
        });
    }

    selectCategoryPackageReference = (value, id, quantity) => {
        let index = this.props.productsByCategory.findIndex(object => {
            return object.productId == id;
        })
        let myObject = this.props.productsByCategory[index]
        myObject['categoryPackageReferenceSelectedQuantity'] = quantity;
        myObject['categoryPackageReferenceSelectedValue'] = value;
    };

    selectQty = (event, index, currentQtyValue) => {
        let list = [...this.state.productsTransfer];
        let item = { ...list[index] };
        item.QtyToTransfer = event.target.value.replace(/\D/g, "");
        item.QtyToTransfer = item.QtyToTransfer == "" || (parseInt(item.QtyToTransfer)) <= currentQtyValue ? item.QtyToTransfer : currentQtyValue
        list[index] = item;
        this.setState({ ...this.state, productsTransfer: list });
    }

    removeTransferProduct = (indexProduct) => {
        let trasnferList = this.state.productsTransfer.filter((item, index) => index != indexProduct);
        this.setState({ ...this.state, productsTransfer: trasnferList });
    }

    clearAllRows = () => {
        this.setState({ productsTransfer: [] });
    };

    mapProductTransfer = (model) => {
        model.sort((a, b) => {
            if (a.ProductName < b.ProductName)
                return -1;
            if (a.ProductName > b.ProductName)
                return 1;
            return 0;
        });

        return model.map((item, indexModel) => {
            const isArrayPackageReference = Array.isArray(item.PackageReference);
            let packageReference;
            let currentQtyValue = item.CurrentQty;

            if (isArrayPackageReference) {
                const packageReferenceList = item.PackageReference.filter((item) =>
                    item.warehouseId === this.state.warehouseFrom
                ).map((pr, index) => {
                    return !pr.packageReference ? (
                        {
                            text: "No lot number",
                            value: "",
                            quantity: pr.quantity,
                            id: index
                        }

                    ) : (
                        {
                            text: pr.packageReference,
                            value: pr.packageReference,
                            quantity: pr.quantity,
                            id: index
                        }
                    )
                });

                if (packageReferenceList.length > 1) {
                    packageReference = () => {
                        if (item.PackageReference) {
                            return (
                                <SelectInputPackageReference
                                    name={`${item.productId}PackageReference`}
                                    id={`${item.productId}`}
                                    label="Package Reference"
                                    options={packageReferenceList}
                                    hintText="Package Reference"
                                    onChange={(event) => {
                                        const selectedOption = packageReferenceList.find(pr => pr.value === event.target.value);
                                        this.selectPackageReference(item.productId, selectedOption);
                                    }}
                                    defaultValue={item.packageReferenceSelected}
                                />
                            )
                        }
                    }
                }
                else {
                    if (item.PackageReference.length > 0) {
                        currentQtyValue = item.PackageReference[0].quantity;
                    }
                    packageReference = () => {
                        return !item.PackageReference[0].packageReference ? (<div>No lot number</div>) : (<div>{item.PackageReference[0].packageReference}</div>)
                    }
                }
            } else {
                currentQtyValue = item.CurrentQty;
                packageReference = () => {
                    return !item.PackageReference ? (<div>No lot number</div>) : (<div>{item.PackageReference}</div>)
                }
            }

            let qtyInput = () => {
                return (
                    <div style={{ marginLeft: 5, marginRight: 5 }}>
                        <TextField
                            type='number'
                            variant="standard"
                            name={`${item.productId}Qty`}
                            id={`quantity-${indexModel}`}
                            value={item.QtyToTransfer}
                            fullWidth={false}
                            hintText={"0"}
                            max={currentQtyValue}
                            onChange={event => { this.selectQty(event, indexModel, currentQtyValue) }}
                        />
                    </div>
                )
            }

            let removeTransfer = () => {
                return (
                    <div>
                        <Button
                            type="IconDeleteButton"
                            className="btn-space glyphicon-remove-circle"
                            onTouchTap={() => this.removeTransferProduct(indexModel)}
                        />
                    </div>
                )
            }

            return {
                productId: (<div>{item.productId}</div>),
                ProductName: (<div>{item.ProductName}</div>),
                SKU: (<div>{item.SKU}</div>),
                PackageReference: packageReference(),
                CurrentQty: <div>{currentQtyValue}</div>,
                QtyToTransfer: qtyInput(),
                DeleteTransfer: removeTransfer(),
            }
        })
    }

    sendBulkTransfer = () => {
        let noPkgRefChosen = this.state.productsTransfer.filter(x => x.packageReferenceSelected === null);

        if (this.props.bulkTransferTitle && this.props.branchTo !== "" && this.props.warehouseTo !== "" && noPkgRefChosen.length === 0) {
            let products = this.state.productsTransfer.map((item) => {
                let qty = item.QtyToTransfer * 1;
                const checkPackageReference = typeof item.packageReferenceSelected === "string" ? item.packageReferenceSelected : item.packageReferenceSelected.value
                return {
                    ProductId: item.productId,
                    PackageReference: checkPackageReference || item.packageReference || "",
                    Quantity: qty
                }
            })
            let data = {
                fromBranch: +this.state.branchFrom,
                fromWarehouse: +this.state.warehouseFrom,
                toBranch: +this.props.branchTo,
                toWarehouse: +this.props.warehouseTo,
                productList: products,
                title: this.props.bulkTransferTitle,
                needReceive: this.props.needReceive,
            }

            // console.log(data);
            this.props.sendBulkTransfer(data);
        } else {
            let error = "";
            if (!this.props.bulkTransferTitle) {
                error = "Please fill up title."
            } else if (this.props.branchTo == "" || this.props.warehouseTo == "") {
                error = "Please select branch and warehouse to transfer to."
            } else if (noPkgRefChosen.length != 0) {
                error = "Please ensure you have selected a package reference for all products."
            }
            alert(error);
        }
    }

    search = () => {
        this.getPurchaseOrders();
    }

    closeDialogPODetails = () => {
        this.setState({ ...this.state, selectedPOOpen: false });
    }

    validateItems = () => {
        const isValid = (this.state.productListEdit.length > 0 || (this.state.categoryListEdit.length > 0));
        this.setState(prevState => {
            return {
                ...prevState,
                errorNoAddedItems: !isValid
            };
        });
        return isValid;
    }

    addAllProductsToTransfer = () => {
        if (this.props.categoryIdSearch && this.props.productsByCategory.length > 0) {
            this.processAllProductCategoryLst();
        }
        else {
            this.props.showError(
                <div>
                    <p>There isn't any result in table!.</p>
                </div>
            )
        }
    }

    addProductsToTransfer = (item) => {
        const productsPO = item.products;
        let arrayModel = []
        productsPO.forEach(element => {
            const productFound = this.state.productsTransfer.filter(x => x.productId === element.productId);
            const currentQuantity = element.actualQuantity;
            const packageReferenceSelected = Array.isArray(element.packageReference) && element.packageReference.length > 0 ? 
                                        element.packageReference[0].value : element.packageReference;

            const model = {
                productId: element.productId,
                ProductName: element.product,
                SKU: element.sku,
                PackageReference: element.packageReference,
                packageReferenceSelected,
                CurrentQty: currentQuantity,
                QtyToTransfer: 0
            }
            if (productFound.length === 0) {
                arrayModel.push(model);
            }
        });
        if (arrayModel.length === 0) {
            this.props.showBulkTransferUpdateSnackbar("These PO products have been added already.");
            this.setState({ ...this.state, showDialogPO: false });
            this.setState({ ...this.state, showDialogCat: false });
        } else {
            let productsTransfer = this.state.productsTransfer.concat(arrayModel);
            this.setState({ ...this.state, productsTransfer, selectedPOOpen: false, showDialogPO: false }, () => {
                arrayModel.forEach((element) => {
                    this.props.getProductQuantity({
                        productId: element.productId,
                        warehouseId: this.state.warehouseFrom,
                        packageReference: element.packageReferenceSelected || ""
                    })
                })
            });
        }
    }

    addOneProductToTransfer = (item) => {
        let arrayModel = []
        let model = {
            productId: item.productId,
            ProductName: item.productName,
            SKU: item.productSKU,
            PackageReference: item.warehouse.packageReference.split('|')[0],
            packageReferenceSelected: item.warehouse.packageReference.split('|')[0],
            CurrentQty: item.warehouse.quantity,
            QtyToTransfer: 0
        }
        if (model.productId != null || model.productId != '') {
            arrayModel.push(model);
        }
        if (arrayModel.length == 0) {
            this.props.showBulkTransferUpdateSnackbar("These products have been added already.");
            this.setState({ ...this.state, showDialogPO: false });
            this.setState({ ...this.state, showDialogCat: false });
        } else {
            // Assuming arrayModel and productsTransfer are arrays of objects with a unique identifier, such as productId.
            let uniqueProductIds = new Set(this.state.productsTransfer.map(c => ({
                productId: c.productId,
                packageReference: c.packageReferenceSelected,
                currentQty: c.CurrentQty
            })));

            let uniqueProductIdsArray = Array.from(uniqueProductIds);

            // Filter the arrayModel to include only the elements that are not in productsTransfer.
            let newProducts = arrayModel.filter(element => {
                return !uniqueProductIdsArray.some(objTransfer =>
                    objTransfer.productId === element.productId &&
                    objTransfer.packageReference === element.PackageReference &&
                    objTransfer.currentQty === element.CurrentQty
                );
            });

            this.barcodeReader = new BarcodeReader();
            let productsTransfer = this.state.productsTransfer.concat(newProducts);
            this.setState({ ...this.state, productsTransfer, selectedPOOpen: false, showDialogCat: true }, () => {
                arrayModel.forEach((element) => {
                    this.props.getProductQuantity({
                        productId: element.productId,
                        warehouseId: this.state.warehouseFrom,
                        packageReference: element.PackageReference || ""
                    })
                })
            });
        }
    }

    handleNewRequestFrom = (selectedOption) => {
        this.clearAllRows();
        const branchId = selectedOption ? selectedOption.value : ``;
        this.setState({ ...this.state, showWarehouseType: true, branchFrom: branchId });
        this.props.updateBranchFrom(branchId);
    };

    handleNewRequestTo = (selectedOption) => {
        const branchId = selectedOption ? selectedOption.value : ``;
        this.setState({ ...this.state, showWarehouseType: true, branchTo: branchId });
        this.props.updateBranchTo(branchId);
    };

    addProductsExcelToTransfer = (productList, excelUploadProducts) => {
        let arrayModel = []
        productList.forEach(item => {
            let productFound = this.state.productsTransfer.filter(x => x.productId == item.productId);

            let selectedPackageReference = excelUploadProducts.filter(x => x.SKU == item.productSKU).length > 0 ? excelUploadProducts.filter(x => x.SKU == item.productSKU)[0].SelectedPackageReference : "";

            let matchedPackageReference = null;
            let currentQuantity = null;

            if (item.warehouses.length === 1) {
                matchedPackageReference = item.warehouses[0].packageReference;
                currentQuantity = item.warehouses[0].quantity;
            } else {
                let filterPackageReferences = item.warehouses.filter(x => x.packageReference == selectedPackageReference);

                if (filterPackageReferences.length > 0) {
                    matchedPackageReference = filterPackageReferences[0].packageReference;
                    currentQuantity = filterPackageReferences[0].quantity;
                }
            }

            const model = {
                productId: item.productId,
                ProductName: item.productName,
                SKU: item.productSKU,
                PackageReference: item.warehouses,
                packageReferenceSelected: matchedPackageReference,
                CurrentQty: currentQuantity,
                QtyToTransfer: 0
            }
            if (productFound.length == 0) {
                arrayModel.push(model);
            }
        });
        if (arrayModel.length == 0) {
            this.props.showBulkTransferUpdateSnackbar("These products have been added already.");
        } else {
            const productsTransfer = this.state.productsTransfer.concat(arrayModel);
            this.setState({ ...this.state, productsTransfer });
        }
    }

    addTitle = (e) => {
        this.setState({ ...this.state, transferTitle: e.target.value });
    }

    lookProductsToTransfer = (item) => {
        this.setState({ ...this.state, selectedPOOpen: true, dialogPOTitle: "PO #" + item.id, selectedPO: item });
    }

    downloadTemplate = () => {
        window.location.href = this.props.apiURL + `unauthorized/bulktransfertemplate`;
    }

    render() {
        const p = this.props;
        let productsBulkTransferColumns = [
            { key: "ProductName", label: "Product Name" },
            { key: "SKU", label: "SKU" },
            { key: "PackageReference", label: "Package Reference" },
            { key: "CurrentQty", label: "Current quantity" },
            { key: "QtyToTransfer", label: "Quantity to transfer" },
            { key: "DeleteTransfer", label: "" }
        ];

        let productsSearchByCategoriesColumns = [
            { key: "ProductName", label: "Product Name" },
            { key: "SKU", label: "SKU" },
            { key: "PackageReference", label: "PackageReference" },
            { key: "Quantity", label: "Quantity" },
            { key: "Icons", label: "", visibleMode: "d-none-xs" }
        ];

        let categories = (this.props.categoriesList || []).map(c => ({
            text: c.name,
            value: c.id.toString()
        }));

        const listPurchaseOrders = (p.purchaseOrders || []).map((item, index) => {
            return {
                ID: item.id,
                Description: item.description,
                Total: item.total,
                View: (<Button
                    key={2}
                    name="IconViewButton"
                    label="View"
                    primary={true}
                    onTouchTap={() => this.lookProductsToTransfer(item)} />),
                Icons: (<Button
                    key={2}
                    id={`buttonAddPOBulkTransfer-${index}`}
                    label="Add"
                    primary={true}
                    onTouchTap={() => this.addProductsToTransfer(item)} />)
            };
        });

        const productAddList = (p.productsByCategory || []).flatMap((obj) => {
            return obj.warehouses.filter((item) =>
                item.warehouseId == this.state.warehouseFrom && item.quantity > 0
            ).map((item, index) => {
                let modeladded = {
                    productId: obj.productId,
                    productName: obj.productName,
                    productSKU: obj.productSKU,
                    warehouse: {
                        quantity: item.quantity,
                        packageReference: item.packageReference
                    }
                };

                return {
                    ProductName: obj.productName || '',
                    productId: obj.productId || '',
                    SKU: obj.productSKU || '',
                    PackageReference: !item.packageReference ? "No lot number" : item.packageReference,
                    Quantity: item.quantity || 0,
                    Icons: (
                        <Button
                            key={index}
                            name="buttonRemoveItem"
                            label="Add"
                            primary={true}
                            onTouchTap={() => this.addOneProductToTransfer(modeladded)}
                        />
                    ),
                };
            });
        });

        return (
            <Grid headerContent={bulkTransferAddCrumb}>
                <PageHeaderWithButton title={LOOKUP.menu.inventory.items.bulkTransferProductDetails.text}>
                    <Button
                        type="SaveButton"
                        label="Create transfer"
                        id="buttonCreateTransfer"
                        style={{ float: 'right' }}
                        secondary={true}
                        onTouchTap={() => this.sendBulkTransfer()}
                    />
                </PageHeaderWithButton>
                <CardSimple cardStyles={{ padding: '0' }}>
                    <div className="row">
                        <div className="col-sm-4 bg-light-grey p-2">
                            <div className="mt-5">
                                <ToggleInput id="toggleNeedToReceive" name={"needReceive"} className="mt-1" label="Need to Receive:" option1="Disabled" option2="Enabled" disabled={this.props.isHighTide || this.props.isInspired} />
                            </div>
                            <div>
                                <BranchSelectAutoCompleteInput
                                    name={`bulkTransferBranchFrom`}
                                    label={LOOKUP.product.bulkTransferProductDetails.from.label}
                                    floatingLabelText={LOOKUP.product.bulkTransferProductDetails.from.label}
                                    options={this.props.allBranches}
                                    hintText={LOOKUP.product.bulkTransferProductDetails.from.hintText}
                                    onChange={this.handleNewRequestFrom}
                                    defaultValue=""
                                />
                            </div>
                            <div>
                                <SelectInput
                                    name={"bulkTransferWarehouseFrom"}
                                    label={`Senders Warehouse`}
                                    id="selectSenderWarehouse"
                                    floatingLabelText={`Senders Warehouse`}
                                    options={this.state.warehouseTypeItems}
                                    hintText={`Senders Warehouse`} />
                            </div>
                            <div>
                                <BranchSelectAutoCompleteInput
                                    name={"bulkTransferBranchTo"}
                                    label={LOOKUP.product.bulkTransferProductDetails.to.label}
                                    floatingLabelText={LOOKUP.product.bulkTransferProductDetails.to.label}
                                    options={this.props.allBranches}
                                    hintText={LOOKUP.product.bulkTransferProductDetails.to.hintText}
                                    onChange={this.handleNewRequestTo}
                                    defaultValue=""
                                />
                            </div>
                            <div>
                                <SelectInput
                                    name="bulkTransferWarehouseTo"
                                    label={`Receiving Warehouse`}
                                    id="selectReceiverWarehouse"
                                    floatingLabelText={`Receiving Warehouse`}
                                    options={this.state.warehouseTypeItems}
                                    hintText={`Receiving Warehouse`} />
                            </div>
                        </div>
                        <div className="col-sm-8 pa-1">
                            <TextInput
                                name={`bulkTransferTitle`}
                                className="search-field mb-2"
                                floatingLabelText={"Title"}
                                label={"Title"}
                                hintText={"Title"}
                                onKeyPress={this.addTitle}
                            />
                            {
                                this.state.warehouseFrom ? (
                                    <React.Fragment>
                                        <Button
                                            type="SearchButton"
                                            className="btn-space mb-2 float-left"
                                            id="buttonImportFromPO"
                                            label="Import product from PO"
                                            secondary={true}
                                            onTouchTap={() => this.getProductFromPO()}
                                        />
                                        <Button
                                            type="SearchButton"
                                            className="btn-space mb-2 float-left"
                                            id="buttonImportFromCategories"
                                            label="Import product from Categories"
                                            secondary={true}
                                            onTouchTap={() => this.getProductFomCategories()}
                                        />
                                        <ExcelUploadBulkTransfer
                                            addProductsExcelToTransfer={this.addProductsExcelToTransfer}
                                            warehouseId={this.state.warehouseFrom}
                                        />
                                        <Button
                                            mini={true}
                                            label="Download Template"
                                            className="btn-space bg-gray-Purple-p POListBtn mb-2 btnNewBrandPOS"
                                            onTouchTap={this.downloadTemplate}
                                        />
                                        <AutoCompleteBulkTransfer
                                            minLength={3}
                                            name={`SearchProductId`}
                                            className="mb-2"
                                            hintText={"Search an existing product"}
                                            options={this.getProductOptions()}
                                            addProductToTransfer={this.addProductToTransfer}
                                            warehouseId={this.state.warehouseFrom}
                                        />
                                    </React.Fragment>
                                ) : (
                                    <TextField
                                        className="bulkTransferSaveDisabledField"
                                        label="Please, select branch and warehouse"
                                        floatingLabelText={"Select branch and warehouse"}
                                        disabled={true}
                                        fullWidth={true}
                                    />
                                )
                            }
                            <GenericTable
                                compName="productsBulkTransfer"
                                columns={productsBulkTransferColumns}
                                rows={this.mapProductTransfer(this.state.productsTransfer)}
                                orderBy={'DESC'}
                                sortBy={''}
                                tableBodyClassName={"inventoryAjudtTable"}
                                stripedRows={true}
                            />
                        </div>
                    </div>
                </CardSimple>
                <DialogInput
                    title={<DialogHeaderWithClose text="Transfer from PO" classicClass="posDialogClassic" handleClose={() => this.closeDialogTrasferFromPO()} />}
                    modal={true}
                    autoScrollBodyContent={true}
                    open={this.state.showDialogPO}
                >
                        <div className="bg-light-opacity mb-2">
                            <SearchPOFilterBulkTrasfer
                                pageName={"dialogBulkTrasfer"}
                                cleanSearch={this.cleanSearch}
                                search={this.search}
                            />
                        </div>
                        <div className="list-table mb-2">
                            <GenericTable
                                compName="PO"
                                className="table_center"
                                tableHeaderClassName="table-pos"
                                tableBodyClassName="table-pos"
                                multiSelectable={false}
                                enableSelectAll={false}
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                displayRowCheckbox={false}
                                stripedRows={true}
                                columns={LOOKUP.purchaseOrder.tableColumnsDialogTransfer}
                                rows={listPurchaseOrders || []}
                            />
                            <Pagination
                                length={p.purchaseOrdersLenght || 0}
                                itemsPerPage={15}
                                activePage={this.state.activePage}
                                onPageChange={(e) => this.changePage(e)}
                                maxButtons={4} />
                        </div>
                </DialogInput>
                <DialogInput
                    title={<DialogHeaderWithClose text={this.state.dialogPOTitle} classicClass="posDialogClassic" handleClose={() => this.closeDialogPODetails()} />}
                    open={this.state.selectedPOOpen}>
                    <div style={{ marginTop: 10 }}>
                        <p>This PO contains the follow products:</p>
                        <br></br>
                        <div>
                            {
                                this.state.selectedPOOpen ? this.state.selectedPO.products.map((item) => {
                                    return <p>- {item.product}{ }</p>;
                                }) : ""
                            }
                        </div>
                    </div>
                </DialogInput>
                <DialogInput
                    title={<DialogHeaderWithClose text="Transfer from Categories" classicClass="posDialogClassic" handleClose={() => this.closeDialogTrasferFromCategories()} />}
                    modal={true}
                    autoScrollBodyContent={true}
                    open={this.state.showDialogCat}
                >
                    <div className="bg-light-opacity p-1 mb-2">
                        <div className="searchBar_container">
                            <ProductCategoriesListBulkTrasfer
                                categoriesList={categories}
                                searchProductByCategory={this.searchProductByCategory}
                                selectAllProductsByCategory={this.selectAllProductsByCategory}
                            />
                        </div>
                    </div>
                    <div className="list-table">
                        <GenericTable
                            compName="PO"
                            className="table_center"
                            tableHeaderClassName="table-pos"
                            tableBodyClassName="table-pos"
                            multiSelectable={false}
                            enableSelectAll={false}
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            displayRowCheckbox={false}
                            columns={productsSearchByCategoriesColumns}
                            rows={productAddList || []}
                        />
                        <Pagination
                            length={p.productCategoryListLength || 0}
                            itemsPerPage={15}
                            activePage={this.state.activePage}
                            onPageChange={(e) => this.changeProductPage(e)}
                            maxButtons={4} />
                    </div>
                </DialogInput>
                <DialogInput
                    title={<DialogHeaderWithClose text={this.state.dialogPOTitle} classicClass="posDialogClassic" handleClose={() => this.closeDialogPODetails()} />}
                    open={this.state.selectedPOOpen}>
                    <div style={{ marginTop: 10 }}>
                        <p>This PO contains the follow products:</p>
                        <br></br>
                        <div>
                            {
                                this.state.selectedPOOpen ? this.state.selectedPO.products.map((item) => {
                                    return <p>- {item.product}{ }</p>;
                                }) : ""
                            }
                        </div>
                    </div>
                </DialogInput>
            </Grid>
        );
    }
}


function mapStateToProps(state, ownProps) {
    let allBranches = [];
    if (state.common.userBranches != null && state.common.userBranches.length > 1 && state.common.branchId != null) {
        for (let i = 0; i < state.common.userBranches.length; i++) {
            allBranches.push({
                text: state.common.userBranches[i].name,
                value: state.common.userBranches[i].id
            })
        }
    }
    const branches = state.common.userBranches || [];
    const list = branches.map(branch => ({
        text: branch.name,
        value: branch.id
    }));

    return {
        dataSource: list,
        categoriesList: state.entity.categoriesList || [],
        categoryIdSearch: state.form["ProductCategoriesListBulkTrasferCategoryIdSearch"] ? parseInt(state.form["ProductCategoriesListBulkTrasferCategoryIdSearch"]) : null,
        products: state.entity.productList || [],
        productsLength: state.entity.productListLength,
        loggedBranch: state.common.branchId,
        productsByCategory: state.entity.productsWarehouses.list || [],
        productCategoryListLength: state.entity.productsWarehouses.total,
        purchaseOrders: state.entity.purchaseOrderList,
        purchaseOrdersLenght: state.entity.purchaseOrderListLength,
        branchId: state.common.branchId,
        allBranches: allBranches,
        apiURL: state.common.store.apiUrl,
        product: state.entity.productForAdjustment,
        productsWarehouses: state.entity.productsWarehouses,
        bulkTransferSuccess: state.entity.bulkTransferSuccess,
        branchFrom: state.form["bulkTransferBranchFrom"],
        warehouseFrom: state.form["bulkTransferWarehouseFrom"],
        branchTo: state.form["bulkTransferBranchTo"],
        warehouseTo: state.form["bulkTransferWarehouseTo"],
        warehouses: state.entity.warehouses,
        bulkTransferTitle: state.form.bulkTransferTitle,
        purchaseNumber: state.form.dialogBulkTrasferPoFilter,
        date: state.form.dialogBulkTrasferDueDateFilter ? new Date(state.form['dialogBulkTrasferDueDateFilter']) : null,
        dateExpected: state.form.dialogBulkTrasferDateExpectedFilter ? new Date(state.form['dialogBulkTrasferDateExpectedFilter']) : null,
        status: state.form.dialogBulkTrasferStatus,
        POSelected: state.form["POSelectedRows"],
        productQuantity: state.entity.productQuantity,
        needReceive: state.form["needReceive"],
        bulkTransferScanProductData: state.entity.bulkTransferScanProductData,
        bulkTransferScannedTime: state.entity.bulkTransferScannedTime,
        isHighTide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateBranchFrom: (branchId) => dispatch(setBulkTransferBranchFrom(branchId)),
        updateBranchTo: (branchId) => dispatch(setBulkTransferBranchTo(branchId)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formError: (name, error) => dispatch(formError(name, error)),
        formInput: (name, value) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        convertBulkToUnit: (model) => dispatch(convertBulkToUnit(model)),
        getWarehouses: (branchId) => dispatch(getWarehouses(branchId)),
        sendBulkTransfer: (model) => dispatch(sendBulkTransfer(model)),
        getPurchaseOrders: (model) => dispatch(getPurchaseOrderForBulkTransfer(model)),
        showBulkTransferUpdateSnackbar: (message) => dispatch({ type: types.SNACKBAR_SHOW_MESSAGE, message: message }),
        getProductQuantity: (model) => dispatch(getProductQuantity(model)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getProductsByCategory: (model) => dispatch(getProductsGroupedFromWarehouse(model)),
        getProductsAutocompleteFromWarehouse: (model) => dispatch(getProductsAutocompleteFromWarehouse(model)),
        getCategories: (model) => dispatch(getCategories(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(BulkTransferSave));